// export default PublicationsAndNewsletters

import { useEffect, useState } from 'react'
// import Icons from '../../../components/common/icons'
import Navigator from '../../../components/common/Navigator'
import { Button } from '../../../components/common'

import DOMPurify from 'dompurify'
import { useActsRules } from './api'

const PublicationsAndNewsletters = () => {
  const { data, isLoading, isError } = useActsRules()
  const acts = data?.data || []

  const [selectedAct, setSelectedAct] = useState<any>(null)
  useEffect(() => {
    if (selectedAct) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [selectedAct])

  if (isLoading) {
    return (
      <section className="py-12 px-4">
        <p>Loading Publications And Newsletters...</p>
      </section>
    )
  }

  if (isError) {
    return (
      <section className="py-12 px-4">
        <p>Publications And Newsletters</p>
      </section>
    )
  }
  const capitalizeHTMLText = (html: string) => {
    if (!html) return ''
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')

    const capitalizeNode = (node: ChildNode) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent || ''
        node.textContent = text.replace(/^\s*\w/, (c) => c.toUpperCase())
      } else if (node.childNodes.length > 0) {
        node.childNodes.forEach(capitalizeNode)
      }
    }

    doc.body.childNodes.forEach(capitalizeNode)
    return doc.body.innerHTML
  }

  return (
    <div className="lg:w-11/12 mx-auto p-4 lg:p-0 bg-white py-10 lg:my-8">
      <Navigator
        title="Publications And Newsletters"
        slug="PUBLICATIONS_AND_NEWSLETTERS"
      />

      <span className="font-barlow font-medium text-4xl leading-[40px] text-black">
        Publications And Newsletters
      </span>

      <hr className="border-t-2 border-primaryBlue mb-6 mt-3" />
      {isLoading ? (
        <p>Loading...</p>
      ) : isError ? (
        <p className="text-red-600">Failed to load Publications.</p>
      ) : acts.length === 0 ? (
        <p className="mb-6">No Publications available.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 px-3 mb-5">
          {acts.map((act: any) => (
            <div
              key={act.id}
              className="border border-gray-200 rounded-lg p-5 shadow-sm flex flex-col justify-between w-full h-[320px]"
            >
              <div>
                <div className="flex items-center justify-between mb-3">
                  <span className="text-PrimaryGray lg:text-[14px] md:text-[11px] xs:text-[12px] font-barlow font-[600]">
                    Posted On:{' '}
                    {new Date(act?.created_at).toLocaleDateString('en-GB', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric',
                    })}
                  </span>
                  {/* <div className="flex items-center gap-1 bg-gray-50 text-black px-2 py-1 rounded-full text-xs">
                  <Icons name="watch" className="text-black" />
                  <p className="font-barlow font-normal lg:text-[12px] text-[9px] leading-[28px] text-black">
                    {act?.readTime}
                  </p>
                </div> */}
                </div>

                {/* <div className="font-barlow font-[600] text-[22px] leading-[27px] text-black mb-2">
                  {act?.title}
                </div> */}
                <div className="font-barlow font-[600] text-[22px] leading-[27px] text-black mb-2">
                  {act?.title
                    ? act.title.charAt(0).toUpperCase() + act.title.slice(1)
                    : ''}
                </div>

                {/* <p
                  className="font-barlow bg-white text-[14px] leading-[27px] text-black mb-2 line-clamp-4"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize( {
                                            capitalizeHTMLText(act?.description || ''),

                      FORBID_ATTR: ['style'],
                    }),
                  }}
                /> */}
                <p
                  className="font-barlow bg-white text-[14px] leading-[27px] text-black mb-2 line-clamp-4"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(
                      capitalizeHTMLText(act?.description || '')
                        .replace(
                          /<ul>/g,
                          `<ul style="list-style-type: disc; padding-left: 1.25rem; margin-bottom: 0.5rem;">`
                        )
                        .replace(
                          /<ol>/g,
                          `<ol style="list-style-type: decimal; padding-left: 1.25rem; margin-bottom: 0.5rem;">`
                        )
                        .replace(
                          /<li>/g,
                          `<li style="margin-bottom: 0.25rem;">`
                        ),
                      {
                        ALLOWED_TAGS: [
                          'p',
                          'span',
                          'strong',
                          'em',
                          'ul',
                          'ol',
                          'li',
                          'br',
                        ],
                        ALLOWED_ATTR: ['class', 'href', 'style'],
                      }
                    ),
                  }}
                />
              </div>

              <div className="mt-4">
                <Button
                  label="View More"
                  size="common"
                  outlined
                  className="border border-PrimaryOrange text-PrimaryOrange rounded-sm px-10 py-4 hover:bg-PrimaryOrange hover:text-white w-full text-[20px]"
                  onClick={() => setSelectedAct(act)}
                />
              </div>
            </div>
          ))}
        </div>
      )}
      {selectedAct && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-[2px] flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-lg max-w-6xl w-full p-6 relative max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <div className="flex flex-col items-start">
                {/* <div className="flex gap-1 bg-gray-50 px-3 py-1 rounded-full text-xs justify-start mb-3">
                  <Icons name="watch" className="text-black" />
                  <p>{selectedAct?.readTime}</p>
                </div> */}

                <span className="text-gray-900 text-sm">
                  Posted On:
                  {new Date(selectedAct?.created_at).toLocaleDateString(
                    'en-GB',
                    {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric',
                    }
                  )}
                </span>
              </div>
            </div>

            <h2 className="text-2xl font-bold mb-3">
              {selectedAct?.title
                ? selectedAct.title.charAt(0).toUpperCase() +
                  selectedAct.title.slice(1)
                : ''}
            </h2>
            <div className="flex justify-between">
              <div
                className="text-[15px] leading-7 text-gray-900 text-black bg-white"
                dangerouslySetInnerHTML={{
                  // __html: selectedAct?.description || '',
                  __html: DOMPurify.sanitize(
                    capitalizeHTMLText(selectedAct?.description || '')
                      .replace(
                        /<ul>/g,
                        `<ul style="list-style-type: disc; padding-left: 1.25rem; margin-bottom: 0.5rem;">`
                      )
                      .replace(
                        /<ol>/g,
                        `<ol style="list-style-type: decimal; padding-left: 1.25rem; margin-bottom: 0.5rem;">`
                      )
                      .replace(/<li>/g, `<li style="margin-bottom: 0.25rem;">`),
                    {
                      ALLOWED_TAGS: [
                        'p',
                        'span',
                        'strong',
                        'em',
                        'ul',
                        'ol',
                        'li',
                        'br',
                      ],
                      ALLOWED_ATTR: ['class', 'href', 'style'],
                    }
                  ),
                }}
              />
              {selectedAct?.image && (
                <div className="md:w-1/3 flex justify-center items-start">
                  <img
                    src={selectedAct.image}
                    alt={selectedAct?.title || 'Advertisement image'}
                    className="rounded-lg shadow max-h-[400px] object-contain"
                  />
                </div>
              )}
            </div>
            <div className="mt-4 flex justify-center gap-4">
              <Button
                outlined
                label="Visit"
                className="border border-PrimaryOrange text-PrimaryOrange rounded-sm px-10 hover:bg-PrimaryOrange hover:text-white min-w-[160px] text-[20px] align-middle"
                // onClick={() => {
                //   let url = selectedAct?.link

                //   if (url) {
                //     const match = url.match(/https?:\/\/.*/)
                //     if (match) {
                //       window.open(match[0], '_blank')
                //     } else {
                //       if (!url.startsWith('http')) {
                //         url = 'https://' + url
                //       }
                //       window.open(url, '_blank')
                //     }
                //   }
                // }}
                onClick={() => {
                  let url = selectedAct?.link

                  if (url) {
                    url = url.replace(/\\\//g, '/')

                    url = url.replace(/^https?\/\//, (match: any) =>
                      match.replace('//', '://')
                    )

                    if (!/^https?:\/\//i.test(url)) {
                      url = 'https://' + url
                    }

                    window.open(url, '_blank', 'noopener,noreferrer')
                  }
                }}
              />

              <Button
                label="Close"
                redOutlined
                className="min-w-[160px] px-10"
                onClick={() => setSelectedAct(null)}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default PublicationsAndNewsletters
